import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, path }) => {
  const token = localStorage.getItem("authToken");

  if (path === "/login" && token) return <Navigate to="/dashboard" replace />
  if (!token && path !== "/login") return <Navigate to="/login" replace />

  return children;
};

export default ProtectedRoute;
